import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CommonUtilityService } from '@app/services/common-utility.service';
import { environment } from '@env/environment';
import { IAddress, MsGuestsService } from '@upr-web-primer/ms-guests';
import { NotificationService } from '@upr-web-primer/notification';
import { LocalStorageService } from '@upr-web-primer/storage';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-payment-address',
  templateUrl: './payment-address.component.html',
  styleUrls: ['./payment-address.component.scss'],
})
export class PaymentAddressComponent implements OnInit {
  gdsDropDownData: any;
  pageLabels: any;
  myAddresses: any = [];
  primaryAddress: any;
  dataLoaded = false;
  @Output() emitSelectedAddress = new EventEmitter<string>();
  @Input() inputAddress: any;
  constructor(
    public commonUtilityService: CommonUtilityService,
    private notification: NotificationService,
    private guestsService: MsGuestsService,
    private cookieService: CookieService,
    private localStorage: LocalStorageService,
    public cdRef: ChangeDetectorRef,
    @Inject('AppRoutes') private appRoutes: any,
    @Inject('GlobalDefaults') public globalDefault: any
  ) {
    this.pageLabels = this.commonUtilityService.getResolvedPageData();
  }

  ngOnInit(): void {
    this.loadUserInfo().then((bool) => {
      if (!bool) {
        this.notification.show(this.pageLabels?.['errCode.E019']);
        this.commonUtilityService.eventDDlTrigger(
          this.pageLabels?.['errCode.E019']
        );
        this.commonUtilityService.changeRoute(this.appRoutes.LOGIN, {
          signoff: true,
        });
      }
    });
  }

  /**
   * loadUserInfo-It will load the User_profileData
   */

  public loadUserInfo(): Promise<boolean> {
    return this.guestsService.personal
      .getAddresses(this.guestsService.helper.getGuestId())
      .then((userData: IAddress[]) => {
        if (!userData) {
          return false;
        }
        this.myAddresses = userData || [];
        if (environment?.showPaymentCard && this.inputAddress) {
          this.primaryAddress = this.myAddresses?.find(
            (address: IAddress) =>
              address.address_id ===
              this.inputAddress?.billing_address?.address_id
          );
        } else {
          this.primaryAddress = this.myAddresses?.find(
            (address: IAddress) => address.primary === true
          );
        }

        this.gdsDropDownData = this.myAddresses?.map((address: IAddress) => {
          return {
            label: address.primary
              ? `<span>${this.pageLabels?.['address.primaryAddress']} </span>
                <br/> 
                ${address.address_line1}`
              : address.address_line1,
            value: address,
            icon: 'home',
          };
        });
        this.dataLoaded = true;
        this.cdRef.detectChanges();
        return true;
      })
      .catch((error: any) => {
        this.dataLoaded = true;
        if (error.status == this.globalDefault.ERROR_401) {
          this.commonUtilityService.setUser();
          localStorage.clear();
          sessionStorage.clear();
          this.cookieService.deleteAll('/', environment.cookieSubDomain);
          const redirectUrl = this.commonUtilityService.getOidcRedirectionUrl();
          this.commonUtilityService.redirectToOidcAppEndSession(redirectUrl);
          return false;
        }
        return true;
      });
  }

  onAddressChange(data: any): void {
    if (data.detail === 'add') {
      this.localStorage.setItem(
        'previousRoute',
        this.globalDefault.PAYMENT_INFO
      );
      this.commonUtilityService.changeRoute(this.appRoutes.ADD_ADDRESS);
    }
    this.emitSelectedAddress.emit(data.detail);
  }
}
